import { Field, FieldProps, Form, Formik, FormikProps } from "formik";
import { transparentize } from "polished";
import * as React from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { v4 } from "uuid";
import * as queryString from "query-string";

import { track } from "../../../analytics";
import styled from "../../../styled-components";
import { media } from "../../../breakpoints";
import ITheme from "../../../theme";

// TODO: replace this with a more modern package
// tslint:disable-next-line
const jsonp = require("jsonp");

const StyledForm = styled(Form)`
  align-items: center;
  border: 1px solid ${props => props.theme.colors.acornsGreen};
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  max-width: 432px;
  padding: 5px;
  width: 100%;

  ${media.TABLET`
    border: none;
    flex-direction: column;
    margin-top: 40px;
    padding: 0;
  `};
`;

const Input = styled.input`
  background: transparent;
  box-shadow: none;
  border: none;
  color: ${props => props.theme.colors.white};
  flex: 1;
  font-size: 14px;
  height: 33px;
  padding: 0 5px;
  transition: border 0.25s ease, color 0.25s ease;
  -webkit-appearance: none;
  -moz-appearance: none;

  &::placeholder {
    color: ${props => transparentize(0.5, props.theme.colors.white)};
  }

  ${media.TABLET`
    border: 1px solid ${(props: { theme: ITheme }) =>
      props.theme.colors.acornsGreen};
    border-radius: 3px;
    height: 100%;
    padding: 13px 10px;
    width: 100%;
  `};
`;

const Button = styled.button`
  background-color: ${props =>
    transparentize(0.25, props.theme.colors.acornsGreen)};
  border: none;
  border-radius: 3px;
  color: ${props => props.theme.colors.white};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  height: 33px;
  width: 180px;

  ${media.TABLET`
    height: 45px;
    margin-top: 20px;
    width: 100%;
  `} &:disabled {
    cursor: not-allowed;
  }
`;

interface IFormValues {
  email: string;
}

interface ISignUpProps {
  email?: string;
}

const SignUpForm: React.SFC<ISignUpProps> = props => {
  return (
    <Formik
      initialValues={{ email: props.email ? props.email : "" }}
      isInitialValid={true}
      enableReinitialize={true}
      onSubmit={(values: IFormValues, formikBag: FormikProps<IFormValues>) => {
        const uuid = v4();
        const referralCode = uuid.substr(uuid.length - 5);
        const params = {
          EMAIL: values.email,
          REFERRALCD: referralCode,
          UTMMEDIUM: "web",
          UTMSOURCE: "saycom",
          b_87df7a4c1ed90dd238c0b4791_6b31d3f95f: "",
          id: "6b31d3f95f",
          subscribe: "Subscribe",
          u: "87df7a4c1ed90dd238c0b4791"
        };

        const url = `https://say.us17.list-manage.com/subscribe/post-json?${queryString.stringify(
          params
        )}`;

        // tslint:disable-next-line
        jsonp(url, { param: "c" }, (err: any, data: any) => {
          if (err) {
            track("Sign Up for Waitlist", { status: "failed" });
            formikBag.setSubmitting(false);

            return toast.error(err.message, {
              position: toast.POSITION.TOP_RIGHT
            });
          } else {
            if (data.result === "error") {
              track("Sign Up for Waitlist", { status: "failed" });
              formikBag.setSubmitting(false);
              if (data.msg.indexOf("already subscribed")) {
                return toast.error(`${values.email} is already subscribed.`, {
                  position: toast.POSITION.TOP_RIGHT
                });
              }
              return toast.error(data.msg, {
                position: toast.POSITION.TOP_RIGHT
              });
            } else {
              track("Sign Up for Waitlist", { status: "success" });
              formikBag.setValues({ email: "" });
              formikBag.setSubmitting(false);
              return toast.success("You are signed up!", {
                position: toast.POSITION.TOP_RIGHT
              });
            }
          }
        });
      }}
      render={(formikBag: FormikProps<IFormValues>) => (
        <StyledForm>
          <Field
            name="email"
            render={({ field, form }: FieldProps<IFormValues>) => (
              <Input
                type="email"
                {...field}
                placeholder="e.g., email@example.com"
              />
            )}
          />

          <Button
            type="submit"
            disabled={formikBag.isSubmitting || !formikBag.isValid}
          >
            {formikBag.isSubmitting ? "Signing Up…" : "Sign Up"}
          </Button>
        </StyledForm>
      )}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Please enter a valid email address.")
          .required("Email address is required")
      })}
    />
  );
};

export default SignUpForm;



// WEBPACK FOOTER //
// ./src/pages/Acorns/AcornsIndex/SignUpForm.tsx